<svg
  class="pl_icon js_squirrel_ignore_suggest"
  role="img"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http:/*                  */
>
  <use xlink:href="/assets-static/icons/pl_icon_duration.svg#pl_icon_duration"></use>
</svg>

<style lang="scss">
  svg {
    flex: 0 0 24px;
    height: 24px;
    margin-right: 16px;
  }
</style>
